import styled from 'styled-components'

export const Page404Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding: 200px 16px;

  h1 {
    color: ${({ theme }) => theme.colors.primary};
    line-height: normal;
  }

  p {
    font-size: 1.5rem;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: bold;
  }

  .title {
    position: relative;
    text-decoration: none;
    transition: all 250ms ease;
    transform: translatez(0);
    perspective: 50px;

    &:before,
    &:after {
      content: '404';
      position: absolute;
      z-index: -1;
      opacity: 0.5;
      transition: all 150ms ease;
    }

    &:before {
      color: #08eddc;
      top: 2px;
      left: 2px;
    }

    &:after {
      color: #09a8fa;
      bottom: 2px;
      right: 2px;
    }

    &:hover:before {
      transform: rotatex(-15deg) rotatey(5deg) scale(1.25);
    }

    &:hover:after {
      transform: rotatey(-5deg) rotatex(15deg) scale(1.25);
    }
  }

  @media (max-width: 500px) {
    gap: 32px;
    .title {
      font-size: 56px;
    }
    p {
      font-size: 12px;
      line-height: 16px;
    }
  }
`
